import {
	UPDATE_PRODUCER,
  UPDATE_PRODUCER_SUCCESS,
	UPDATE_PRODUCER_FAIL,
} from "./Constants"

const initialState = {
		isLoading: false,
		error: null,
		data: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case UPDATE_PRODUCER:
			return {
				...state,
				isLoading: true
			}
		case UPDATE_PRODUCER_SUCCESS:
			return {
				...state,
				isLoading: false,
				data: action.payload
			}
		case UPDATE_PRODUCER_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}